import { measureTextWidth } from './measureTextWidth';

const GAP_BETWEEN_TEXTS = 4;

const truncateToWidth = (text: string, maxWidth: number, fontSize: string, fontWeight: string): string => {
	let truncated = text;
	let currentWidth = measureTextWidth(text, fontSize, fontWeight);

	while (currentWidth > maxWidth && truncated.length > 3) {
		truncated = truncated.slice(0, -1);
		currentWidth = measureTextWidth(`${truncated}...`, fontSize, fontWeight);
	}

	return truncated.length < text.length ? `${truncated}...` : text;
};

/**
 * Truncates name and description to fit available width.
 * Allocates 30% to name, 70% to description to prioritize showing the action.
 */
export const smartTruncateByWidth = (
	name: string,
	description: string,
	availableWidth: number,
): { name: string; description: string } => {
	const nameWidth = measureTextWidth(name, '12px', 'bold');
	const descWidth = measureTextWidth(description, '12px', 'normal');
	const totalWidth = nameWidth + descWidth + GAP_BETWEEN_TEXTS;

	if (totalWidth <= availableWidth) {
		return { name, description };
	}

	const nameMaxWidth = (availableWidth - GAP_BETWEEN_TEXTS) * 0.3;
	const descMaxWidth = (availableWidth - GAP_BETWEEN_TEXTS) * 0.7;

	return {
		name: truncateToWidth(name, nameMaxWidth, '12px', 'bold'),
		description: truncateToWidth(description, descMaxWidth, '12px', 'normal'),
	};
};
